import React, { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const err = (e) => e?.response?.data?.detail || "Erreur";

export default function DemarcheSendDialog({ dossierId, step, onClose, onSent }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!step) return;
    setD(null);
    api.get(`/dossiers/${dossierId}/demarches/${step}/draft`).then((r) => setD(r.data)).catch((e) => { toast.error(err(e)); onClose(); });
  }, [dossierId, step, onClose]);
  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/dossiers/${dossierId}/demarches/${step}/send`, { to: d.to, subject: d.subject, body: d.body });
      toast.success(r.data.simulated ? "Envoi simulé (mode simulation : rien n'est parti) — statut et date mis à jour" : "Demande envoyée");
      onSent?.();
      onClose();
    } catch (e) { toast.error(err(e)); } finally { setBusy(false); }
  };
  const set = (k) => (e) => setD({ ...d, [k]: e.target.value });
  return (
    <Dialog open={!!step} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="demarche-send-dialog">
        <DialogHeader><DialogTitle>{d?.label || "Demande"} {d && <span className="ml-2 text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-amber-100 text-amber-800" data-testid="demarche-provisoire-badge">Modèle provisoire</span>}</DialogTitle></DialogHeader>
        {!d ? <Loader2 className="w-5 h-5 animate-spin m-6" /> : (
          <div className="space-y-3 text-sm">
            <label className="block"><span className="text-xs text-norea-textMuted">À ({d.partner})</span>
              <input className="input-field mt-1 w-full" value={d.to} onChange={set("to")} data-testid="demarche-send-to" /></label>
            <label className="block"><span className="text-xs text-norea-textMuted">Objet</span>
              <input className="input-field mt-1 w-full" value={d.subject} onChange={set("subject")} data-testid="demarche-send-subject" /></label>
            <label className="block"><span className="text-xs text-norea-textMuted">Message</span>
              <textarea className="input-field mt-1 w-full min-h-[200px] font-mono text-xs" value={d.body} onChange={set("body")} data-testid="demarche-send-body" /></label>
            <div className="text-xs" data-testid="demarche-send-pieces">
              {d.piece_labels.length > 0 && <div className="text-emerald-700">Pièces jointes : {d.piece_labels.join(", ")}</div>}
              {d.missing_files.length > 0 && <div className="text-amber-700">Pièces absentes du dossier (non jointes) : {d.missing_files.join(", ")}</div>}
              {d.simulation && <div className="text-norea-textMuted mt-1">Mode simulation : l'envoi est enregistré dans l'historique mais rien ne part.</div>}
            </div>
            <div className="flex justify-end gap-2">
              <button className="btn-secondary text-xs" onClick={onClose} data-testid="demarche-send-cancel">Annuler</button>
              <button className="btn-primary text-xs inline-flex items-center gap-1.5" disabled={busy || !d.to} onClick={send} data-testid="demarche-send-confirm">
                {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}Envoyer</button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
